import { Component, computed, inject, input, output } from '@angular/core';
import { Spinner } from '../../../spinner';
import { NttDropdownMenu } from '../../dropdown-menu';

@Component({
  selector: 'ntt-dropdown-menu-item',
  imports: [Spinner],
  templateUrl: './dropdown-menu-item.html',
  styleUrl: './dropdown-menu-item.scss',
})
export class NttDropdownMenuItem {
  private readonly _dropdownMenu = inject(NttDropdownMenu, { optional: true });

  readonly label = input.required<string>();
  readonly icon = input<string | null>(null);
  readonly shortcut = input<string | null>(null);
  readonly disabled = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly closeOnClick = input<boolean>(true);

  readonly itemClick = output<void>();

  protected readonly hasIcon = computed(() => !!this.icon());
  protected readonly hasShortcut = computed(() => !!this.shortcut());
  protected readonly isBlocked = computed(
    () => this.disabled() || this.loading(),
  );

  protected _onClick(): void {
    if (!this.isBlocked()) {
      this.itemClick.emit();
      if (this.closeOnClick() && this._dropdownMenu) {
        this._dropdownMenu.close();
      }
    }
  }
}
